import { optional, parse, string } from "~/util/validate.js";

import env from "./env.json" with { type: "json" };

if (!import.meta.env?.PRODUCTION) {
	try {
		// @ts-ignore
		const overrides = await import("./env.local.json", {
			with: { type: "json" },
		});
		Object.assign(env, overrides.default);
	} catch {}
}

export const apiHost = parse(string, env.API_HOST);
export const wsHost = parse(string, env.WS_HOST);
export const environment = parse(optional(string), env.ENVIRONMENT);
export const sentryDsn = parse(optional(string), env.SENTRY_DSN);
export const segmentWriteKey = parse(optional(string), env.SEGMENT_WRITE_KEY);

export const sha = parse(optional(string), import.meta.env?.GIT_SHA);
